import { FC, useEffect, useState } from 'react';
import { IFinancialResult, IFinancialResultsResponse } from '../types';
import { useWindowSize } from '../hooksHelpers';
import FinancialDesktopCalendars from '../components/FinancialDesktopCalendars';
import MobileFinancialCalendar from '../components/MobileFinancialCalendar';

interface IProps {}

const FinancialResults: FC<IProps> = props => {
  const [financialResultsArr, setFinancialResultsArr] = useState<
    IFinancialResult[]
  >([]);

  const size = useWindowSize();

  const getFinancialResultsData = () => {
    fetch(
      '/wp-json/wp/v2/financial_result?per_page=100&order=desc&orderby=slug',
    )
      .then(response => response.json())
      .then((data: IFinancialResultsResponse[]) => {
        setFinancialResultsArr(
          data.map(financialResult => ({
            year: financialResult.title.rendered,
            documents: financialResult.ACF,
          })),
        );
      });
  };

  useEffect(function () {
    getFinancialResultsData();
  }, []);

  return (
    <div>
      <h3 className="wp-title">
        Financial<span>Results</span>
      </h3>
      {size.width <= 1054 ? (
        <MobileFinancialCalendar financialResultsArr={financialResultsArr} />
      ) : (
        <FinancialDesktopCalendars financialResultsArr={financialResultsArr} />
      )}
    </div>
  );
};

export default FinancialResults;
